import axios from 'axios';
import router from "@/router";
import store from "@/store";
axios.defaults.validateStatus = () => true
// 创建 axios 实例
const http = axios.create({
    baseURL:  process.env.VUE_APP_API_URL, // API的基础路径
    timeout: 20000, // 请求超时时间
});


// 请求拦截器
http.interceptors.request.use(
    config => {
        // 在发送请求之前做些什么，例如添加 token
        const token = store.state.token;

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        // 对请求错误做些什么
        return Promise.reject(error);
    }
);

// 响应拦截器
http.interceptors.response.use(
    response => {

        if(response.data.code==401) {
            const currentPath = router.currentRoute.path;
            
            store.dispatch('logout');
            if (currentPath !== '/login') {
                router.push('/login').catch(err => {
                    // 忽略导航重复错误
                    if (err.name !== 'NavigationDuplicated') {
                        console.error(err);
                    }
                });
            }
        }


        if(response.data.code==402) {


        }



        // 对响应数据做点什么
        return response.data; // 返回响应数据中的 data 部分
    },
    error => {
        console.log("有错误",error)
        // 对响应错误做点什么
        if (error.response && error.response.status === 401) {
            // 处理401错误，例如重定向到登录页面等
            console.error('Unauthorized, please login again.');
        }
        return false;
    }
);

export default http;
